import React from 'react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Checkbox } from '../components/ui/checkbox';
import { Loader2, ChevronRight, ChevronLeft } from 'lucide-react';

const inputCls = "rounded-xl h-10 border-slate-200 text-sm";

function StepPersonal({ reg, updateReg, canGoNext, onNext, t }) {
  return (
    <div className="space-y-3" data-testid="reg-step-1">
      <p className="text-sm font-bold text-slate-700">{t('personalData')}</p>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-xs font-semibold">{t('firstName')} *</Label>
          <Input data-testid="register-first-name" value={reg.first_name}
            onChange={e => updateReg('first_name', e.target.value)} placeholder={t('firstNamePlaceholder')} className={inputCls} required /></div>
        <div><Label className="text-xs font-semibold">{t('lastName')} *</Label>
          <Input data-testid="register-last-name" value={reg.last_name}
            onChange={e => updateReg('last_name', e.target.value)} placeholder={t('lastNamePlaceholder')} className={inputCls} required /></div>
      </div>
      <div><Label className="text-xs font-semibold">{t('email')} *</Label>
        <Input type="email" data-testid="register-email" value={reg.email}
          onChange={e => updateReg('email', e.target.value)} placeholder={t('emailPlaceholder')} className={inputCls} required /></div>
      <div><Label className="text-xs font-semibold">{t('phone')}</Label>
        <Input type="tel" data-testid="register-phone" value={reg.phone}
          onChange={e => updateReg('phone', e.target.value)} placeholder={t('phonePlaceholder')} className={inputCls} /></div>
      <div><Label className="text-xs font-semibold">{t('password')} *</Label>
        <Input type="password" data-testid="register-password" value={reg.password}
          onChange={e => updateReg('password', e.target.value)} placeholder={t('passwordPlaceholder')} className={inputCls} required minLength={6} /></div>
      
      <p className="text-xs font-bold text-slate-500 mt-3">{t('indirizzo')}</p>
      <div><Label className="text-xs font-semibold">{t('ragioneSociale')}</Label>
        <Input data-testid="register-ragione-sociale" value={reg.ragione_sociale}
          onChange={e => updateReg('ragione_sociale', e.target.value)} className={inputCls} /></div>
      <div><Label className="text-xs font-semibold">{t('indirizzo')}</Label>
        <Input data-testid="register-indirizzo" value={reg.indirizzo}
          onChange={e => updateReg('indirizzo', e.target.value)} className={inputCls} /></div>
      <div className="grid grid-cols-3 gap-2">
        <div><Label className="text-xs font-semibold">{t('cap')}</Label>
          <Input data-testid="register-cap" value={reg.cap} onChange={e => updateReg('cap', e.target.value)} className={inputCls} /></div>
        <div><Label className="text-xs font-semibold">{t('citta')}</Label>
          <Input data-testid="register-citta" value={reg.citta} onChange={e => updateReg('citta', e.target.value)} className={inputCls} /></div>
        <div><Label className="text-xs font-semibold">{t('paese')}</Label>
          <Input data-testid="register-paese" value={reg.paese} onChange={e => updateReg('paese', e.target.value)} className={inputCls} /></div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-xs font-semibold">{t('partitaIva')}</Label>
          <Input data-testid="register-partita-iva" value={reg.partita_iva} onChange={e => updateReg('partita_iva', e.target.value)} className={inputCls} /></div>
        <div><Label className="text-xs font-semibold">{t('codiceFiscale')}</Label>
          <Input data-testid="register-codice-fiscale" value={reg.codice_fiscale} onChange={e => updateReg('codice_fiscale', e.target.value)} className={inputCls} /></div>
      </div>
      <div><Label className="text-xs font-semibold">{t('pecSdi')}</Label>
        <Input data-testid="register-pec-sdi" value={reg.pec_sdi} onChange={e => updateReg('pec_sdi', e.target.value)} className={inputCls} /></div>
      
      <Button onClick={onNext} disabled={!canGoNext} data-testid="reg-next-1" className="w-full btn-primary h-10">
        {t('next')} <ChevronRight className="w-4 h-4 ml-1" />
      </Button>
    </div>
  );
}

function StepBilling({ reg, updateReg, onBack, onNext, t }) {
  return (
    <div className="space-y-3" data-testid="reg-step-2">
      <p className="text-sm font-bold text-slate-700">{t('billingData')}</p>
      <div className="flex items-center gap-2 bg-blue-50 p-3 rounded-xl">
        <Checkbox id="billing-same" checked={reg.billing_same_as_personal}
          onCheckedChange={v => updateReg('billing_same_as_personal', v)} data-testid="billing-same-checkbox" />
        <Label htmlFor="billing-same" className="text-sm cursor-pointer">{t('billingSameAsPersonal')}</Label>
      </div>
      {!reg.billing_same_as_personal && (
        <div className="space-y-3 animate-fade-in-up">
          <div><Label className="text-xs font-semibold">{t('ragioneSociale')}</Label>
            <Input value={reg.billing_ragione_sociale} onChange={e => updateReg('billing_ragione_sociale', e.target.value)} className={inputCls} /></div>
          <div><Label className="text-xs font-semibold">{t('indirizzo')}</Label>
            <Input value={reg.billing_indirizzo} onChange={e => updateReg('billing_indirizzo', e.target.value)} className={inputCls} /></div>
          <div className="grid grid-cols-3 gap-2">
            <div><Label className="text-xs font-semibold">{t('cap')}</Label>
              <Input value={reg.billing_cap} onChange={e => updateReg('billing_cap', e.target.value)} className={inputCls} /></div>
            <div><Label className="text-xs font-semibold">{t('citta')}</Label>
              <Input value={reg.billing_citta} onChange={e => updateReg('billing_citta', e.target.value)} className={inputCls} /></div>
            <div><Label className="text-xs font-semibold">{t('paese')}</Label>
              <Input value={reg.billing_paese} onChange={e => updateReg('billing_paese', e.target.value)} className={inputCls} /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs font-semibold">{t('partitaIva')}</Label>
              <Input value={reg.billing_partita_iva} onChange={e => updateReg('billing_partita_iva', e.target.value)} className={inputCls} /></div>
            <div><Label className="text-xs font-semibold">{t('codiceFiscale')}</Label>
              <Input value={reg.billing_codice_fiscale} onChange={e => updateReg('billing_codice_fiscale', e.target.value)} className={inputCls} /></div>
          </div>
          <div><Label className="text-xs font-semibold">{t('pecSdi')}</Label>
            <Input value={reg.billing_pec_sdi} onChange={e => updateReg('billing_pec_sdi', e.target.value)} className={inputCls} /></div>
        </div>
      )}
      <div className="flex gap-3">
        <Button onClick={onBack} variant="outline" className="flex-1 rounded-full h-10">
          <ChevronLeft className="w-4 h-4 mr-1" /> {t('back')}
        </Button>
        <Button onClick={onNext} data-testid="reg-next-2" className="flex-1 btn-primary h-10">
          {t('next')} <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
}

function StepConsents({ reg, updateReg, onBack, onSubmit, loading, onShowLpd, onShowDisclaimer, t }) {
  const canSubmit = reg.accept_lpd && reg.accept_disclaimer;
  return (
    <div className="space-y-4" data-testid="reg-step-3">
      <div className="bg-slate-50 rounded-xl p-4 space-y-4">
        <div className="flex items-start gap-3">
          <Checkbox id="accept-lpd" checked={reg.accept_lpd}
            onCheckedChange={v => updateReg('accept_lpd', v)} data-testid="accept-lpd-checkbox" className="mt-0.5" />
          <div>
            <Label htmlFor="accept-lpd" className="text-sm cursor-pointer font-semibold">{t('acceptLpd')}</Label>
            <button type="button" onClick={onShowLpd} className="block text-xs text-blue-600 hover:underline mt-1">{t('readLpd') || 'Leggi'}</button>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <Checkbox id="accept-disclaimer" checked={reg.accept_disclaimer}
            onCheckedChange={v => updateReg('accept_disclaimer', v)} data-testid="accept-disclaimer-checkbox" className="mt-0.5" />
          <div>
            <Label htmlFor="accept-disclaimer" className="text-sm cursor-pointer font-semibold">{t('acceptDisclaimer')}</Label>
            <button type="button" onClick={onShowDisclaimer} className="block text-xs text-blue-600 hover:underline mt-1">{t('readDisclaimer') || 'Leggi'}</button>
          </div>
        </div>
      </div>
      <div className="flex gap-3">
        <Button onClick={onBack} variant="outline" className="flex-1 rounded-full h-10">
          <ChevronLeft className="w-4 h-4 mr-1" /> {t('back')}
        </Button>
        <Button onClick={onSubmit} disabled={loading || !canSubmit} data-testid="register-submit-btn" className="flex-1 btn-primary h-10">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : t('register')}
        </Button>
      </div>
    </div>
  );
}

export function RegisterWizard({ reg, updateReg, step, setStep, setError, loading, onSubmit, onShowLpd, onShowDisclaimer, t }) {
  const canGoStep2 = reg.first_name && reg.last_name && reg.email && reg.password && reg.password.length >= 6;

  return (
    <div className="space-y-4">
      {step === 1 && (
        <StepPersonal reg={reg} updateReg={updateReg} canGoNext={canGoStep2}
          onNext={() => { if (canGoStep2) { setStep(2); setError(''); } }} t={t} />
      )}
      {step === 2 && (
        <StepBilling reg={reg} updateReg={updateReg}
          onBack={() => setStep(1)} onNext={() => { setStep(3); setError(''); }} t={t} />
      )}
      {step === 3 && (
        <StepConsents reg={reg} updateReg={updateReg}
          onBack={() => setStep(2)} onSubmit={onSubmit} loading={loading}
          onShowLpd={onShowLpd} onShowDisclaimer={onShowDisclaimer} t={t} />
      )}
      <div className="flex justify-center gap-2 mt-3">
        {[1, 2, 3].map(s => (
          <div key={s} className={`w-2 h-2 rounded-full transition-all ${s === step ? 'bg-blue-500 w-6' : 'bg-slate-300'}`} />
        ))}
      </div>
    </div>
  );
}
